import { FC } from "react";
import { ShowHeaderProps } from "./show-header.types";
import { ChevronLeft } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ShowHeader: FC<ShowHeaderProps> = ({ title, rightAddon }) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Stack
      py={2}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"flex-start"}
    >
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        sx={{ cursor: "pointer" }}
        onClick={goBack}
      >
        <ChevronLeft fontSize="large" />
        <Typography variant="h5">{title}</Typography>
      </Stack>

      {rightAddon}
    </Stack>
  );
};

export { ShowHeader };
